export const colors = {
	blue: "#007DC3",
	lightBlue: "#007DC3",
	skyBlue: "#EBF5FF",
	white: "#F8F8F8",
	black: "#131314",
};

export const sizes = {
	w650: 650,
	w450: 450,
	w300: 300,
	w270: 270,
	w250: 250,
	w200: 200,
	w150: 150,
	h35: 35,
};

import { API_URL as baseApiUrl } from "@/config/env";

export const setupAPIs = {
	getScenario: baseApiUrl + "Scenario/GetScenario?",
	getUserCountries: baseApiUrl + "GetUserCountries?",
	getCGForCountry: baseApiUrl + "CustomerGroup/GetCstmrGrpforCntry?",
	getCGRefData: baseApiUrl + "Scenario/GetCustomerGroupReferenceData?",
	getCGDetail: baseApiUrl + "CustomerGroup/GetCstmrGrpDetail?",
	getRelshipLevel: baseApiUrl + "Scenario/GetTrustLevel",
	getCustomers: baseApiUrl + "CustomerGroup/GetCustomerSrch?",

	getPGForCountry: baseApiUrl + "ProductGroup/GetProductGroupsForCountry?",
	getPGDetail: baseApiUrl + "ProductGroup/GetProductGroupDetail?",
	submitCustomerGroup: baseApiUrl + "CustomerGroup/SubmitCstmrGrp",
	saveCustomerGroup: baseApiUrl + "CustomerGroup/SaveCstmrGrp",
	cloneCustomerGroup: baseApiUrl + "CustomerGroup/CloneCstmrGrp",

	submitProductGroupEdit: baseApiUrl + "ProductGroup/SubmitProductGroup?isEdittrue",
	saveProductGroupEdit: baseApiUrl + "ProductGroup/SaveProductGroup?isEdittrue",

   submitProductGroupCreate: baseApiUrl + "ProductGroup/SubmitProductGroup?isEditfalse",
   saveProductGroupCreate: baseApiUrl + "ProductGroup/SaveProductGroup?isEditfalse",

	getProductGroups: baseApiUrl + "ProductGroup/GetProductSrch?",

	scDetails: baseApiUrl + "Scenario/GetScenarioDetails?",
	ImportExcel: baseApiUrl + "Scenario/ImportExcel?",
	ImportExcelSKU : baseApiUrl + "Scenario/ImportExcelSKU?",
	GetProductGroupbyCountry: baseApiUrl +"Scenario/GetProductGroupbyMolecule",
   uploadFileForCustomerGroup: baseApiUrl + "CustomerGroup/UploadFileForCustomerGroup",

   downloadAttachment: baseApiUrl + "Define/DownloadFile?",
};
